export default {
  login: {
    title: 'Ins Reseller Platform',
    username: 'Username',
    password: 'Password',
    login: 'Login',
    welcomeBack: 'Welcome back',
    loginSuccess: 'Login successful',
    loginFailed: 'Login failed',
    networkError: 'Network error, please try again later',
    error: {
      username_required: 'Please enter your username',
      password_required: 'Please enter your password',
      login_success: 'Login successful',
      login_failed: 'Login failed'
    }
  },
  common: {
    confirm: 'Confirm',
    cancel: 'Cancel',
    save: 'Save',
    delete: 'Delete',
    edit: 'Edit',
    create: 'Create',
    search: 'Search',
    reset: 'Reset',
    loading: 'Loading',
    success: 'Success',
    error: 'Error',
    warning: 'Warning',
    info: 'Information',
    tip: 'Tip',
    appName: 'Reseller MS',
    none: 'None',
    copy: 'Copy',
    copySuccess: 'Copy successful',
    copyFailed: 'Copy failed'
  },
  header: {
    balance: 'Balance',
    recharge: 'Recharge',
    logout: 'Logout',
    profile: 'Profile',
    welcome: 'Welcome'
  },
  menu: {
    dashboard: 'Dashboard',
    account: 'Account',
    billing: 'Billing Records',
    proxy: 'Proxy',
    staticproxy: 'Static Residential Proxy',
    users: 'User',
    resellerManagement: 'Reseller Management',
    resellerList: 'Reseller List',
    resellerAnalytics: 'Analytics'
  },
  dashboard: {
    title: 'Dashboard',
    totalBalance: 'Total Balance',
    todayIncome: 'Today Income',
    monthlyIncome: 'Monthly Income',
    yearlyIncome: 'Yearly Income',
    recentTransactions: 'Recent Transactions',
    statistics: 'Statistics'
  },
  account: {
    title: 'Account Management',
    accountInfo: 'Account Information',
    transactions: 'Transactions',
    recharge: 'Recharge',
    withdraw: 'Withdraw',
    apiKey: 'API Key',
    apiSecret: 'API Secret',
    notifyUrl: 'Notify URL',
    copyNotifyUrl: 'Copy Notify URL',
    resetKey: 'Reset Key',
    resetWarning: 'Reset API Key will invalidate existing keys, are you sure to continue?',
    resetPassword: 'Reset Password',
    currentBalance: 'Current Balance',
    rechargeAmount: 'Recharge Amount',
    error: {
      copy: 'Copy failed',
      currentRequired: 'Please enter current password',
      newRequired: 'Please enter new password',
      confirmRequired: 'Please enter confirm password',
      passwordLength: 'Password must be at least 6 characters',
      passwordMismatch: 'Passwords do not match'
    },
    success: {
      copy: 'Copy successful'
    },
    remainingTime: 'Remaining Time',
    scanQRCode: 'Please scan the QR code with your mobile phone to complete payment',
    paymentAmount: 'Payment Amount'
  },
  billing: {
    title: 'Billing Management',
    orderNo: 'Order No.',
    amount: 'Amount',
    status: 'Status',
    createTime: 'Create Time',
    paymentMethod: 'Payment Method',
    // Statistics Cards
    monthlyConsume: 'Monthly Consumption',
    monthlyRecharge: 'Monthly Recharge',
    // Search Form
    transactionType: 'Transaction Type',
    orderType: 'Order Type',
    transactionTime: 'Transaction Time',
    startDate: 'Start Date',
    endDate: 'End Date',
    all: 'All',
    consume: 'Consumption',
    refund: 'Refund',
    recharge: 'Recharge',
    staticProxy: 'Static Proxy Order',
    ipRenewal: 'IP Renewal',
    rechargeOrder: 'Recharge Order',
    search: 'Search',
    reset: 'Reset',
    export: 'Export',
    // Table Columns
    orderNumber: 'Order No.',
    transactionTypeLabel: 'Transaction Type',
    changeAmount: 'Change Amount',
    beforeBalance: 'Before Balance',
    afterBalance: 'After Balance',
    orderTypeLabel: 'Order Type',
    transactionDate: 'Transaction Date',
    // Transaction Detail Dialog
    transactionDetail: 'Transaction Detail',
    remark: 'Remark',
    noRemark: 'None',
    // Messages
    fetchTransactionsFailed: 'Failed to fetch transaction records',
    fetchStatsFailed: 'Failed to fetch monthly statistics',
    exportPreparing: 'Preparing export file...',
    exportSuccess: 'Export successful',
    exportFailed: 'Export failed',
    loadConditionsFailed: 'Failed to load search conditions',
    // File names and error messages
    transactionRecords: 'Transaction Records',
    exportTransactionsFailed: 'Failed to export transaction records',
    exportFailedPrefix: 'Export failed',
    unknownError: 'Unknown error',
    pleaseSelectRecords: 'Please select records to export'
   },
   proxy: {
    title: 'Proxy Management',
    proxyList: 'Proxy List',
    createProxy: 'Create Proxy',
    editProxy: 'Edit Proxy',
    proxyDetail: 'Proxy Detail',
    // Table Columns
    id: 'ID',
    ip: 'IP',
    oldIp: 'Old IP',
    port: 'Port',
    location: 'IP Location',
    orderNo: 'Order No.',
    days: 'Days',
    traffic: 'Traffic',
    totalTraffic: 'Total Traffic',
    usedTraffic: 'Used Traffic',
    expirationTime: 'Expiration Date',
    tag: 'Tag',
    createTime: 'Order Time',
    operations: 'Operations',
    renewalTime: 'Renewal Time',
    renewalResult: 'Renewal Result',
    reason: 'Reason',
    // Status
    enableStatus: 'Enable Status',
    onlineStatus: 'Online Status',
    enabled: 'Enabled',
    disabled: 'Disabled',
    online: 'Online',
    offline: 'Offline',
    success: 'Success',
    failed: 'Failed',
    // Actions
    copyProxy: 'Copy Proxy',
    viewDetails: 'View Details',
    details: 'Details',
    renewal: 'Renewal',
    // Tabs
    purchasedIpList: 'Purchased IP List',
    renewalRecord: 'Renewal Record',
    // Traffic
     unlimitedTraffic: 'Unlimited Traffic',
     // Icon Legend
     iconLegend: 'Icon Legend'
   },
  breadcrumb: {
    dashboard: 'Dashboard',
    account: 'Account',
    billing: 'Billing',
    proxy: 'Proxy',
    user: 'User Management',
    staticproxy: 'Static Residential Proxy',
    users: 'Users',
    resellerManagement: 'Reseller Management',
    resellerlist: 'Reseller List',
    reselleranalytics: 'Analytics'
  },
  user: {
    username: 'Username',
    email: 'Email',
    status: 'Status',
    isReseller: 'Is Reseller',
    yes: 'Yes',
    no: 'No',
    actions: 'Actions',
    usernamePlaceholder: 'Please enter username',
    statusPlaceholder: 'Please select status',
    statusAll: 'All',
    statusActive: 'Active',
    statusDisabled: 'Disabled',
    createTime: 'Create Time',
    updateTime: 'Update Time',
    lastLoginTime: 'Last Login Time',
    usernameRequired: 'Please enter username',
    usernameLengthLimit: 'Username length should be between 3-20 characters',
    passwordRequired: 'Please enter password',
    passwordLengthLimit: 'Password length should be at least 6 characters',
    remark: 'Remark',
    addUser: 'Add User',
    password: 'Password',
    confirmStatusChange: 'Confirm to {action} this user?',
    enable: 'enable',
    disable: 'disable',
    tip: 'Tip',
    statusChangeSuccess: '{action} successful',
    statusChangeFailed: '{action} failed',
    statusUpdateFailed: 'Status update failed',
    submitSuccess: 'Submit successful',
    getUserListFailed: 'Failed to get user list',
    confirmRenewIP: 'Confirm to renew this IP?',
    renewSuccess: 'Renew successful'
  },
  
  // Proxy Management Page
  proxyStatic: {
    // Tabs
    purchase: 'Purchase',
    purchased: 'Purchased IP List',
    renewalRecord: 'Renewal Record',
    
    // Purchase Form
    selectPackage: 'Select Package',
    selectRegion: 'Select Region',
    deliveryProtocol: 'Delivery Protocol',
    pleaseSelectRegion: 'Please select region',
    quantity: 'Quantity:',
    calculating: 'Calculating...',
    paymentAmount: 'Payment Amount:',
    includeExtraFee: 'Include extra fees',
    payNow: 'Pay Now',
    reset: 'Reset',
    
    // Service Features
    highSpeedStable: 'High-speed and stable, 99.9% uptime guarantee',
    globalCoverage: 'Global coverage, supports 200+ countries and regions',
    unlimitedBandwidth: 'Unlimited bandwidth, no concurrent connection limit',
    professionalSupport: 'Professional technical support, 7x24 hours online service',
    
    // Professional Features
    realUserSimulation: 'Real User Simulation',
    realUserSimulationDesc: 'Harder to be identified as proxy by websites, improving stealth',
    highAnonymity: 'High Anonymity',
    highAnonymityDesc: 'Reduces the risk of being monitored and blocked',
    lowBlockRate: 'Low Block Rate',
    lowBlockRateDesc: 'Lower probability of being blocked by websites when using IP',
    highAuthenticity: 'High Authenticity',
    highAuthenticityDesc: 'Harder to be identified as proxy by websites, improving stealth',
    betterStability: 'Better Stability',
    betterStabilityDesc: 'Harder to be identified as proxy by websites, improving stealth',
    
    // Order Confirmation
    confirmOrderInfo: 'Confirm Order Information',
    packageInfo: 'Package Information',
    region: 'Region',
    protocol: 'Protocol',
    tag: 'Tag',
    pleaseEnterTag: 'Please enter tag (optional)',
    maxCharacters: 'Maximum 20 characters',
    paymentMethod: 'Payment Method',
    
    // IP Status Tabs
    activeIPs: 'Active IPs',
    expiringIPs: 'Expiring IPs',
    expiredIPs: 'Expired IPs',
    daysToExpire: ' days to expire',
    
    // Search Form
    enterIPAddress: 'Enter IP address',
    addIP: '+ Add IP',
    pleaseEnterOrderNo: 'Please enter order number',
    pleaseEnterOrderNumber: 'Please enter order number',
    collapse: 'Collapse',
    expand: 'Expand',
    pleaseEnterTag: 'Please enter tag',
    all: 'All',
    yes: 'Yes',
    no: 'No',
    startDate: 'Start Date',
    endDate: 'End Date',
    to: 'to',
    pleaseEnterUserID: 'Please enter user ID',
    enableStatus: 'Enable Status',
    pleaseSelect: 'Please select',
    enabled: 'Enabled',
    disabled: 'Disabled',
    onlineStatus: 'Online Status',
    search: 'Search',
    export: 'Export',
    
    // Renewal Record Search
    userID: 'User ID',
    renewalStatus: 'Renewal Status',
    success: 'Success',
    failed: 'Failed',
    renewalTime: 'Renewal Time',
    
    // Payment Confirmation
    confirmPayment: 'Confirm Payment',
    confirmPaymentMessage: 'Confirm payment ¥{amount} to purchase proxy service?',
    confirm: 'Confirm',
    cancel: 'Cancel',
    paymentSuccess: 'Payment successful! Order No: {orderNo}',
    paymentFailed: 'Payment failed',
    paymentFailedRetry: 'Payment failed, please try again',
    
    // Order number
    orderNumber: 'Order No.',
    isReseller: 'Is Reseller',
    orderTime: 'Order Time',
    
    // Table Columns
    renewalResult: 'Renewal Result',
    totalTraffic: 'Total Traffic',
    usedTraffic: 'Used Traffic',
    enableStatus: 'Enable Status',
    
    // Common
    none: 'None',
    
    // Error Messages
    priceCalculationFailed: 'Price calculation failed',
    getPackageListFailed: 'Failed to get package list',
    getRegionListFailed: 'Failed to get region list',
    getProxyListFailed: 'Failed to get proxy list',
    getRenewalListFailed: 'Failed to get renewal list',
    pleaseEnterValidIPFormat: 'Please enter valid IP address format',
    proxyInfoCopied: 'Proxy information copied to clipboard',
    getProxyInfoFailed: 'Failed to get proxy information',
    copyProxyInfoFailed: 'Failed to copy proxy information',
    networkError: 'Network error',
    copyFailedManualCopy: 'Copy failed, please copy manually',
    renewalSuccess: 'Renewal successful',
    renewalFailed: 'Renewal failed',
    preparingExport: 'Preparing export file...',
    exportSuccess: 'Export successful',
    exportFailed: 'Export failed',
    pleaseSelectPackage: 'Please select package',
    pleaseEnterQuantity: 'Please enter quantity',
    pleaseSelectPaymentMethod: 'Please select payment method',
    balancePayment: 'Balance Payment',
    alipay: 'Alipay',
    wechatPay: 'WeChat Pay',
    confirmRenewProxy: 'Are you sure you want to renew this proxy?',
    pleaseSelectRecords: 'Please select records to export',
    
    // Batch operations
    batchUpdateTag: 'Batch Update Tag',
    newTag: 'New Tag',
    pleaseEnterNewTag: 'Please enter new tag',
    selectedRecordsCount: 'Selected {count} records',
    batchUpdateTagSuccess: 'Batch update tag successful',
    batchUpdateTagFailed: 'Batch update tag failed',
    
    // Batch sync proxy info
    batchSyncProxyInfo: 'Batch Refresh Proxy Info',
    pleaseSelectRecordsForSync: 'Please select records to refresh proxy info',
    pleaseSelectRecordsForTag: 'Please select records to modify tag',
    
    // Batch copy proxy
    batchCopyProxy: 'Batch Copy Proxy',
    pleaseSelectRecordsForCopy: 'Please select records to copy',
    batchCopySuccess: 'Successfully copied {count} proxy information to clipboard',
    getBatchProxyInfoFailed: 'Failed to get batch proxy information',
    batchCopyProxyFailed: 'Batch copy proxy failed',
    
    // New columns
     hostname: 'Hostname',
     accountName: 'Username',
     password: 'Password',
    
    // Copy functionality
    hostnameCopied: 'Hostname copied to clipboard',
    accountNameCopied: 'Username copied to clipboard',
    passwordCopied: 'Password copied to clipboard',
    copyFailed: 'Copy failed',
    
    // Sync IP functionality
    syncIP: 'Sync IP',
    systemAccount: 'System Account',
    userID: 'User ID',
    proxyType: 'Proxy Type',
    ipLocation: 'IP Location',
    productType: 'Product Type',
    days: 'Days',
    channel: 'Channel',
    deductBalance: 'Deduct Balance',
    unitPrice: 'Unit Price',
    tag: 'Tag',
    remark: 'Remark',
    syncExcel: 'Sync Excel',
    uploadExcel: 'Upload Excel Document',
    excelTip: 'Only xlsx/xls files are allowed, and file size cannot exceed 10MB',
     excelRequirementTip: 'Note: Please ensure the Excel document header includes "主机", "IP地址", "账号", "密码", "端口", "代理ID", "线路ID", "过期时间" and other fields (field names must be in Simplified Chinese)',
     excelTips: 'Document headers must include fields "Host, IP Address, Port, Account Name, Password, Proxy ID, Line ID, Expiration Date". Host and Line ID can be left empty if not available',
     pleaseSelectSystemAccount: 'Please select system account',
    pleaseEnterUserID: 'Please enter user ID',
    pleaseSelectIPLocation: 'Please select IP location',
    pleaseSelectProductType: 'Please select product type',
    pleaseSelectDays: 'Please select days',
    pleaseSelectChannel: 'Please select channel',
    pleaseSelectDeductBalance: 'Please select deduct balance',
    pleaseEnterUnitPrice: 'Please enter unit price',
    unitPriceMustGreaterThanZero: 'Unit price must be greater than 0',
    pleaseUploadExcel: 'Please upload Excel document',
    onlyExcelAllowed: 'Only Excel files are allowed',
    fileSizeLimit: 'File size cannot exceed 10MB',
    submitSync: 'Submit Sync',
    resetForm: 'Reset Form',
    syncSuccess: 'Sync successful',
    syncFailed: 'Sync failed',
    getCountryListFailed: 'Failed to get country list',
    getProductListFailed: 'Failed to get product list',
    gk: 'GK',
    other: 'Other',
    thirtyDays: '30 Days',
    sixtyDays: '60 Days',
    ninetyDays: '90 Days',
    
    // Sync IP functionality
     syncIP: 'Sync IP',
     syncIPForm: 'Sync IP Form',
     systemAccount: 'System Account',
     pleaseSelectSystemAccount: 'Please select system account',
     pleaseSelectLocation: 'Please select IP location',
     productType: 'Product Type',
     pleaseSelectProduct: 'Please select product type',
     pleaseSelectDays: 'Please select days',
     zone: 'Zone',
     pleaseSelectZone: 'Please select zone',
     unitPrice: 'Unit Price',
     pleaseEnterUnitPrice: 'Please enter unit price',
     isDeductBalance: 'Deduct Balance',
     pleaseSelectDeductBalance: 'Please select whether to deduct balance',
     remark: 'Remark',
     pleaseEnterRemark: 'Please enter remark',
     syncExcel: 'Sync Excel',
     selectFile: 'Select File',
     excelTip: 'Only xlsx/xls files are allowed, and the file size should not exceed 10MB',
     submitSync: 'Submit Sync',
     onlyExcelAllowed: 'Only Excel files are allowed',
     fileSizeLimit: 'File size cannot exceed 10MB',
     pleaseSelectFile: 'Please select a file',
    
    // Batch update tag functionality
    batchUpdateTag: 'Batch Update Tag',
     newTag: 'New Tag',
     pleaseEnterNewTag: 'Please enter new tag',
     selectedRecordsCount: 'Selected Records',
     batchUpdateTagSuccess: 'Batch update tag successful',
     batchUpdateTagFailed: 'Batch update tag failed',
     
     // 批量刷新代理信息
        batchSyncProxyInfo: 'Batch Refresh Proxy Info',
        pleaseSelectRecordsForSync: 'Please select records to refresh proxy info',
        pleaseSelectRecordsForTag: 'Please select records to modify tag'
  },
  reseller: {
    // Basic information
    resellerList: 'Reseller List',
    resellerName: 'Reseller Name',
    resellerLevel: 'Reseller Level',
    parentReseller: 'Parent Reseller',
    contactPerson: 'Contact Person',
    contactPhone: 'Contact Phone',
    contactEmail: 'Contact Email',
    registrationTime: 'Registration Time',
    lastLoginTime: 'Last Login Time',
    accountStatus: 'Account Status',
    totalUsers: 'Total Users',
    totalRevenue: 'Total Revenue',
    monthlyRevenue: 'Monthly Revenue',
    commissionRate: 'Commission Rate',
    actions: 'Actions',
    
    // New fields
     username: 'Username',
     companyName: 'Company Name',
     contactName: 'Contact Name',
     accountAmount: 'Account Balance',
     apiInfo: 'API Information',
     apiKey: 'API Key',
     secretKey: 'Secret Key',
     notifyUrl: 'Notify URL',
     status: 'Status',
     isSuper: 'Super Admin',
     remark: 'Remark',
     createTime: 'Create Time',
     updateTime: 'Update Time',
     keyword: 'Keyword',
     resellerId: 'Reseller ID',
     yes: 'Yes',
     no: 'No',
     viewApiInfo: 'View API Info',
     resellerIdPlaceholder: 'Please enter reseller ID',
    
    // Placeholder text
    keywordPlaceholder: 'Username, company name or contact name',
    usernameRequired: 'Please enter username',
    companyNamePlaceholder: 'Please enter company name',
     contactNamePlaceholder: 'Please enter contact name',
     contactPhonePlaceholder: 'Please enter contact phone',
     remarkPlaceholder: 'Please enter remark',
     password: 'Password',
     passwordPlaceholder: 'Please enter password',
     passwordPlaceholderEdit: 'Leave blank to not modify password',
     enterPassword: 'Please enter password',
     leaveBlankToNotModify: 'Leave blank to not modify password',
     passwordRequired: 'Password is required',
    
    // Status
    active: 'Active',
    inactive: 'Inactive',
    pending: 'Pending',
    enabled: 'Enabled',
    disabled: 'Disabled',
    
    // Level
    primary: 'Primary Reseller',
    secondary: 'Secondary Reseller',
    tertiary: 'Tertiary Reseller',
    
    // Operations
    viewDetails: 'View Details',
    editReseller: 'Edit Reseller',
    disableReseller: 'Disable Reseller',
    enableReseller: 'Enable Reseller',
    deleteReseller: 'Delete Reseller',
    addReseller: 'Add Reseller',
    recharge: 'Recharge',
    
    // Form validation
    resellerNameRequired: 'Please enter reseller name',
    contactPersonRequired: 'Please enter contact person',
    contactPhoneRequired: 'Please enter contact phone',
    contactEmailRequired: 'Please enter contact email',
    commissionRateRequired: 'Please enter commission rate',
    passwordLengthLimit: 'Password length should be at least 6 characters',
    
    // Recharge related
    rechargeTitle: 'Recharge',
    rechargeAmount: 'Recharge Amount',
    rechargeAmountPlaceholder: 'Please enter recharge amount',
    rechargeRemark: 'Remark',
    rechargeRemarkPlaceholder: 'Please enter remark',
    rechargeAmountRequired: 'Please enter recharge amount',
    rechargeAmountMin: 'Minimum recharge amount is ¥1',
    rechargeAmountInvalid: 'Please enter a valid amount',
    rechargeRemarkRequired: 'Please enter remark',
    rechargeConfirm: 'Confirm to recharge ¥{amount} for this reseller?',
    rechargeSuccess: 'Recharge successful',
    rechargeFailed: 'Recharge failed',
    rechargeProcessing: 'Processing recharge...',
     
    // Analytics
    analytics: 'Analytics',
    revenueAnalytics: 'Revenue Analytics',
    userGrowth: 'User Growth',
    orderAnalytics: 'Order Analytics',
    topResellers: 'Top Resellers',
    revenueChart: 'Revenue Chart',
    userGrowthChart: 'User Growth Chart',
    orderChart: 'Order Chart',
    
    // Time range
    today: 'Today',
    thisWeek: 'This Week',
    thisMonth: 'This Month',
    thisYear: 'This Year',
    
    // Statistics
    totalResellerCount: 'Total Resellers',
    activeResellerCount: 'Active Resellers',
    newResellerCount: 'New Resellers',
    totalCommission: 'Total Commission',
    
    // Operation confirmation
     deleteConfirm: 'Are you sure to delete this reseller?',
     disableConfirm: 'Are you sure to disable this reseller?',
     enableConfirm: 'Are you sure to enable this reseller?',
     confirmStatusChange: 'Are you sure to {action} this reseller?',
     superAdminStatusCannotChange: 'Super admin status cannot be changed',
     enable: 'enable',
     disable: 'disable',
     rechargeInDevelopment: 'Recharge function is under development...',
     operationSuccess: 'Operation successful',
     operationFailed: 'Operation failed',
     getResellerListFailed: 'Failed to get reseller list',
     getResellerInfoFailed: 'Failed to get reseller information',
     getAnalyticsDataFailed: 'Failed to get analytics data'
  },
  error: {
    '404': 'Sorry, the page you visited does not exist',
    '403': 'Sorry, you do not have permission to access this page',
    back: 'Go Back',
    home: 'Go Home'
  }
}
